import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@mui/material'
import * as React from 'react'
import { screenInfoModals } from './ScreenInfo'
import { useStuartMutate } from '../../../APIs/Hooks/PhpAPIHooks'
import { useParams } from 'react-router-dom'
import { useQueryClient } from 'react-query'

function ConfirmReleaseDialog({
  open,
  setOpen,
  billingStatus,
}: {
  open: screenInfoModals | undefined
  setOpen: any
  billingStatus: string
}) {
  const { screen_id } = useParams()
  const queryClient = useQueryClient()
  const { mutate: updateScreen } = useStuartMutate(
    `/screen/updateScreen.php?ScreenID=${screen_id}&CollectionStatus=PEN&BillingStatus=${billingStatus}`,
    async () => {
      await queryClient.invalidateQueries({
        queryKey: ['PhpAPI', '/stuart', '/screen/getScreen.php'],
      })
      await queryClient.invalidateQueries({
        queryKey: ['PhpAPI', '/stuart', '/screen/getScreensForHolding.php'],
      })
      setOpen(undefined)
    },
  )

  return (
    <Dialog
      open={open === screenInfoModals.RELEASE}
      onClose={() => setOpen(undefined)}
    >
      <DialogTitle>{'Confirm Release'}</DialogTitle>
      <DialogContent>
        <DialogContentText>
          The current draft screen request will be updated to 'PENDING' and
          released to all the selected bubbles for collection. You will no
          longer be able to edit any aspect of this request.
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button
          onClick={() => setOpen(undefined)}
          color="error"
        >
          Cancel
        </Button>
        <Button
          onClick={() => updateScreen()}
          color="success"
        >
          Continue & Release
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default ConfirmReleaseDialog
